export default {
  request_url:'http://csadmin.csjgxx.net/api/'
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 